import { Grid, Stack } from "@mui/material";
import { Label } from "./SelectAccountType";
import { NationalityField } from "./NationalityField";
import { FileUpload } from "./FileUploadField";
import { SocialSecurityField } from "./SocialSecurityField";
import ReKycWealthSource from "./styled-components/ReKycWealthSource";
import AddressLookUpComponent from "./AddressLookup";
import { useUserSlice } from "src/store/features/user.slice";
import { ReKycAboutYouDetails } from "./ReKycAboutYouDetails";
import { useEffect } from "react";
import { trackEvent } from "src/Amplitude";

export default function ReKycAboutYou() {
  const {
    reKycDetails: { edd: enhancedDueDiligence, recordType },
    salesforceDetails: { submitted },
  } = useUserSlice();

  useEffect(() => {
    trackEvent("Visit_Page", { page: "Re-KYC Application About You" }, "Re-KYC");
  }, []);

  return (
    <Grid container spacing={1} padding={"20px"}>
      <ReKycAboutYouDetails />
      <Grid item xs={12} sm={6}>
        <Stack spacing={1}>
          <Label text="Nationality" />
          <NationalityField />
        </Stack>
      </Grid>
      {recordType === "Individual" && enhancedDueDiligence && (
        <Grid item xs={12}>
          <ReKycWealthSource />
        </Grid>
      )}
      <Grid item xs={12}>
        <Stack mb={1}>
          <Label text="Search Home Address" />
        </Stack>
        <Stack>
          <AddressLookUpComponent />
        </Stack>
      </Grid>
      {!submitted && (
        <Grid item xs={12} mt={2}>
          <SocialSecurityField />
        </Grid>
      )}
      <Grid item xs={12} mt={2}>
        <Label text="Upload Documents" />
        <FileUpload />
      </Grid>
    </Grid>
  );
}
